export const title = 'Downloads since launch';

Total number of app installations since launch.
